import { Button } from '@mui/material'
import { message } from 'antd'
import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'
import io from 'socket.io-client'
import store from 'store2'

import { JWT_TOKEN_NAME } from '../../../../../constants/auth-key'
import { axiosInstance } from '../../../../../hooks/useAxios'
import { useUser } from '../../../../../hooks/useUser'

const BackfillButton = () => {
  const { merchant } = useUser()
  const [loading, setLoading] = useState<boolean>(false)

  const username = merchant?.prefix

  // เชื่อม web-socket app โดยตรง (REACT_APP_SOCKET_SERVICE) — คนละ host กับ
  // facebook ws ของ dashboard-api (REACT_APP_WS_SERVICE) ที่ backfill emit ไม่ถึง
  useEffect(() => {
    const socketUrl = process.env.REACT_APP_SOCKET_SERVICE
    if (!username || !socketUrl) {
      return
    }

    const jwtToken = store.get(JWT_TOKEN_NAME)
    const socket = io(socketUrl, {
      transports: ['websocket'],
      path: '/ws/',
      reconnection: true,
      query: { token: jwtToken ?? '' },
    })

    const subscribe = () => socket.emit('subscribe', { username })
    subscribe()
    socket.on('connect', subscribe)

    socket.on('order:backfill:completed', (data: { totalOrders?: number }) => {
      message.success(
        `ดึงคำสั่งซื้อย้อนหลังเสร็จแล้ว ${data?.totalOrders ?? 0} รายการ`,
      )
    })
    socket.on('order:backfill:failed', (data: { error?: string }) => {
      message.error(
        `ดึงคำสั่งซื้อย้อนหลังล้มเหลว: ${data?.error ?? 'ไม่ทราบสาเหตุ'}`,
      )
    })

    return () => {
      socket.off()
      socket.disconnect()
    }
  }, [username])

  const handleBackfill = async () => {
    setLoading(true)
    try {
      await axiosInstance.post('/shopee/backfill')
      message.info('กำลังดึงคำสั่งซื้อย้อนหลัง 2 เดือน จะแจ้งเตือนเมื่อเสร็จ')
    } catch (e) {
      const err = e as AxiosError<{ message?: string }>
      if (err.response?.status === 409) {
        message.warning('ร้านนี้เคยดึงคำสั่งซื้อย้อนหลังแล้ว')
      } else {
        message.error('เริ่มดึงย้อนหลังไม่สำเร็จ กรุณาลองใหม่')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={handleBackfill}
      disabled={loading}
    >
      {loading ? 'กำลังเริ่ม...' : 'ดึงคำสั่งซื้อย้อนหลัง 2 เดือน'}
    </Button>
  )
}

export default BackfillButton
